export const AGGREGATE_BID_ID = 54
